<template>
<!--   <v-card flat color="transparent" class="ch-post__related ch-sticky d-none d-lg-block" v-if="items && items.length > 0"> 
    <v-card-text class="pa-1">
      <span class="text-overline primary--text text-X-caslon">Related Articles</span>
      <hr class="primary mb-2" />
      <ul class="pl-0 caption">
        <li v-for="(item, i) in items" :key="i" class="mb-4">
          <a :href="item.link" v-html="item.title"></a>
        </li>
      </ul>
    </v-card-text>
  </v-card> -->
  <div class="ch-related mb-6 mx-auto is-sticky" v-if="items && items.length > 0">
    <v-subheader class="text-overline primary--text">Related Posts</v-subheader>
    <v-list dense three-line class="grey lighten-4 v-list--striped py-0 ch-highlights__list">
      <v-list-item v-for="(item, i) in items" :key="i" :href="item.link">
  <!--       <v-list-item-avatar>
          <v-icon small color="primary">mdi-record</v-icon>
        </v-list-item-avatar> -->
        <v-list-item-content>
          <v-list-item-subtitle v-html="item.title" class="secondary-X-text"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: 'RelatedPosts',

    props: ['items']
  }
</script>

<style lang="sass" scoped>
  .ch-related.is-sticky
    position: -webkit-sticky
    position: sticky
    top: 80px
</style>